module.exports = __webpack_public_path__ + "static/media/Flowchart_SW.3819d0a5.jpg";